<div class="sticky-header">
  <div class="navbar-wrapper">
    <div class="navbar-content-left">
      <ng-content select=".left-content"></ng-content>
    </div>
    <div class="navbar-content-middle">
      <h1 class="navbar-title" title="{{ pageTitle }}">
        {{ pageTitle }}
      </h1>
      <span class="navbar-spinner" *ngIf="showLoadingSpinner">
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      </span>
      <ng-content select=".after-title-content"></ng-content>
    </div>   
    <div role="toolbar" class="navbar-content-right">
      <ng-content></ng-content>
    </div>
  </div>
</div>

<ng-content select='[slot="secondary-ribbon"]'></ng-content>
